const base = '/tasks';

export const taskManagementRoutes = {
  base: base,
  tasks: base, // it's not duplication, task management base route shows tasks, it's okay
  recognitions: `${base}/recognitions`,
  taskGroups: `${base}/taskGroups`,
} as const;
